import { render } from "./gendersStep.vue?vue&type=template&id=28988a03&ts=true"
import script from "./gendersStep.vue?vue&type=script&lang=ts"
export * from "./gendersStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__